
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import Icon from 'vux/src/components/icon/index.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {mapGetters} from 'vuex'
import util from "./utils/util";
import Vue from 'vue';
import { UNION_PAY_AUTH_FLAG} from "./store/modules/consts";

export default {
name: 'app',
computed: mapGetters([
'headShow',
'loading',
'footerShow',
'pageTitle',
]),
data() {
return {
backUrl: "protocol://backtoapp",
backQuery: {},
baseUrl: this.$baseUrl,
init: true
}
},
created() {
this.init = false;
console.log('App created');
},
mounted() {
console.log('App mounted');

window.onpopstate = () => {
console.log("onpopstate =============");
this.backUrlClick();

};


const oScript = document.createElement('script');
oScript.src = 'https://open.95516.com/s/open/js/upsdk.js';
document.body.appendChild(oScript);
console.log('this.init:', this.init);
if(!this.init){
this.init = true;
if(util.isUnionPay()){
console.warn('###判定为重新进云闪付应用###');
let unionPayAuthInfo = window.localStorage.getItem(UNION_PAY_AUTH_FLAG);
if(unionPayAuthInfo){
unionPayAuthInfo = JSON.parse(unionPayAuthInfo);
}
if(unionPayAuthInfo && unionPayAuthInfo.flag){

window.localStorage.removeItem(UNION_PAY_AUTH_FLAG);
if(unionPayAuthInfo.time - new Date().getTime() < 15 * 1000){

} else {
Vue.prototype.$store.dispatch('LogOut').then(() => {

}).catch(err => {

});
}
} else {
Vue.prototype.$store.dispatch('LogOut').then(() => {

}).catch(err => {

});
}
}
}
},
methods: {
Logout: function () {
this.$router.push({path: '/logout'})
},
handlerBackUrl: function (currentBackUrl, currentBackQuery) {

console.log("82",currentBackUrl,currentBackQuery);
if(currentBackUrl==undefined||currentBackUrl==null||currentBackUrl==''){
return;
}
if (currentBackUrl !== "") {
this.backUrl = currentBackUrl;
this.backQuery = currentBackQuery;
}
},
backUrlClick: function () {
console.log("90",this.backUrl)
if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' && this.backUrl.indexOf('backtoapp') > -1) {
WeixinJSBridge.invoke('closeWindow', {}, function (res) {

});
return;
}

if (this.backUrl.indexOf('backtoapp') > -1) {
console.log('###aaaa');
if(util.isUnionPay()){
console.log('###sdk 正常？：', Boolean(window.upsdk));
try{
upsdk.closeWebApp();
}catch (e){
console.log(e);
}
} else {
window.location.href = this.backUrl;
}
} else {
console.log('###bbb', this.backUrl, ' location_path:', window.location.pathname, '   href:', window.location.href);
if(util.isUnionPay()){
if(window.location.pathname !== '/index'){
this.$router.push({path: this.backUrl, query: this.backQuery});
return;
}

try{
upsdk.closeWebApp();
}catch (e){
console.log(e);
}
} else {
this.$router.push({path: this.backUrl, query: this.backQuery});
}
}
},
},
directives: {
TransferDom
},
components: {
Tabbar,
TabbarItem,
XHeader,
Loading,
ViewBox,
Icon
}
}



// WEBPACK FOOTER //
// ./src/App.vue